import { Component } from '@angular/core';
import {   IonicPage,
  NavController,
  NavParams,
  LoadingController } from 'ionic-angular';
import { Http } from "@angular/http";
import config from "../../config/config";

/**
 * Generated class for the ListaExcluidosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage() 
@Component({
  selector: 'page-lista-excluidos',
  templateUrl: 'lista-excluidos.html',
})
export class ListaExcluidosPage {
  usuario: any;
  bemVindo: any;
  operarios: any[];
  items: any[];
  pes:number = 1;
  constructor(
    public navCtrl: NavController,
    private _http: Http,
    public loadingCtrl: LoadingController,

    public navParams: NavParams
  ) {
  }

  ionViewDidLoad() {
    this.usuario = this.navParams.get("usuario");
    this.bemVindo = this.navParams.get("bemVindo"); 
    this.todos();


    // console.log(this.items);
    
  }
  todos() {
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    this._http
      .get(config.urlAPI + "usuario/excluidos", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        
        
        
        let env = [];

        for (let w = 0; w < res.length; w++) {
          if (!res[w].dados) {
            res[w].dados = {
              foto: "public/perfildefault.jpg"
            }
          }else if (res[w].dados.foto == null) {
            res[w].dados.foto = "public/perfildefault.jpg";
            // this.foto = res[w].dados.foto;
        // console.log('entrei 3');

          }
          let ineter = "";

          // if (element.dados.interesse != null) {
          //   let inte = JSON.parse(element.dados.interesse);
          //   for (let q = 0; q < inte.length; q++) {
          //     if (inte[q].isChecked) {
          //       ineter += inte[q].val + ", ";
          //     }
          //   }
          // }
          res[w].intereses = ineter;
          env.push(res[w]);
          this.operarios = env;
          this.items = env; 
          // console.log(this.items); 

        }

        loading.dismiss();
        
      })
      .catch(error => {
        console.log(error);
        
        loading.dismiss();
      });
  }
 
  initializeItems() {
    this.items = [];

    for (var i = 0; i < this.operarios.length; ++i) {
      var it = this.operarios[i];
      this.items.push(it);
    }
  }
  getItems(ev: any) {
    this.initializeItems();
    const val = ev;

    // if the value is an empty string don't filter the items
    if (this.pes == 1) {
      if (val && val.trim() != "") {
        this.items = this.items.filter(item => {
          return (
            item.nome
              .toString()
              .toLowerCase()
              .indexOf(val.toLowerCase()) > -1
          );
        });
      } else {
        this.initializeItems();
      }
    }
    if (this.pes == 2) {
      if (val && val.trim() != "") {
        this.items = this.items.filter(item => {
          return (
            item.cpf
              .toString()
              .toLowerCase()
              .indexOf(val.toLowerCase()) > -1
          );
        });
      } else {
        this.initializeItems();
      }
    }
    if (this.pes == 3) {
      if (val && val.trim() != "") {
        this.items = this.items.filter(item => {
          return (
            item.intereses
              .toString()
              .toLowerCase()
              .indexOf(val.toLowerCase()) > -1
          );
        });
      } else {
        this.initializeItems();
      }
    }
    ev = "";
  }
  filtrofunc(pes) {
  }

}


// WEBPACK FOOTER //
// ./src/pages/lista-excluidos/lista-excluidos.ts